function o(n, t) {
  return t != null ? n instanceof Error && n.code === t : n instanceof Error && n.code != null;
}
export {
  o as default
};
